import {createButton} from "react-social-login-buttons";
 
const config = {
  icon: 'google',
  iconFormat: name => `fa fa-${name} social-google`,
  style: { background: "white", color:"black" },
  activeStyle: { background: "white", opacity:'0.9' }
};
const GoogleButton = createButton(config);
 
export default GoogleButton;